import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes, FaGlobe, FaMoon, FaSun } from 'react-icons/fa'; 
import styles from './Navbar.module.css';
import logo from '../assests/logo.png'; 
import { db } from '../firebaseConfig';
import { doc, onSnapshot } from "firebase/firestore";

const Navbar = ({ lang, setLang, darkMode, setDarkMode }) => {
  const [sidebar, setSidebar] = useState(false);
  const [tickerData, setTickerData] = useState({ tickerEN: "", tickerUr: "" });
  const [ticker, setTicker] = useState("Loading...");

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "settings", "tickerData"), (doc) => {
      if (doc.exists()) setTickerData(doc.data());
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    setTicker(lang === 'EN' ? tickerData.tickerEN : tickerData.tickerUr);
  }, [lang, tickerData]);

  // navLinks mein route path bhi add kar diya hai taake sahi category page open ho
  const navLinks = [
    { en: 'Home', ur: 'صفحہ اول', path: '/' }, 
    { en: 'Pakistan', ur: 'پاکستان', path: '/category/Pakistan' },
    { en: 'Latest News', ur: 'تازہ ترین', path: '/category/Taza Tareen' }, 
    { en: 'Politics', ur: 'سیاست', path: '/category/Siyasat' },
    { en: 'International', ur: 'بین الاقوامی', path: '/category/Bain-Ul-Aqwami' }, 
    { en: 'Health', ur: 'صحت', path: '/category/Sehat' },
    { en: 'City News', ur: 'شہر کی نیوز', path: '/category/Shehar-Ki-News' }, 
    { en: 'Ads', ur: 'اشتہارات', path: '/category/Ishtiharat' },
    { en: 'Sports', ur: 'کھیل', path: '/category/Khel' }, 
    { en: 'Showbiz', ur: 'شوبز', path: '/category/Showbiz' },
    { en: 'Business', ur: 'بزنس', path: '/category/Business' }, 
    { en: 'Columns', ur: 'آج کا کالم', path: '/category/Aaj-Ka-Column' },
    { en: 'About Us', ur: 'ہمارے بارے میں', path: '/about' }
  ];

  return (
    <header className={`${styles.header} ${darkMode ? styles.dark : ''}`}>
      <div className={styles.topBar}>
        <div className={styles.menuIcon} onClick={() => setSidebar(true)}><FaBars /> MENU</div>
        <Link to="/"><img src={logo} alt="Logo" className={styles.logoImg} /></Link>
        <div className={styles.settings}>
          <button onClick={() => setLang(lang === 'EN' ? 'UR' : 'EN')} className={styles.iconBtn}>
            <FaGlobe /> {lang}
          </button>
          <button onClick={() => setDarkMode(!darkMode)} className={styles.iconBtn}>
            {darkMode ? <FaSun /> : <FaMoon />}
          </button>
        </div>
      </div>

      <div className={styles.tickerWrapper}>
        <div className={styles.tickerLabel}>{lang === 'EN' ? 'LATEST' : 'تازہ ترین'}</div>
        <div className={styles.tickerContent} dir={lang === 'EN' ? 'ltr' : 'rtl'}>
           <div className={styles.tickerTrack}>
              <img src={logo} alt="Logo" className={styles.tickerLogo} />
              <span className={styles.tickerText}>{ticker}</span>
              <img src={logo} alt="Logo" className={styles.tickerLogo} />
           </div>
        </div>
      </div>

      <nav className={styles.secondNav}>
        {navLinks.map((item, index) => (
          <Link key={index} to={item.path} className={styles.navLink}>
            {lang === 'EN' ? item.en : item.ur}
          </Link>
        ))}
      </nav>

      <div className={`${styles.sidebar} ${sidebar ? styles.active : ''}`}>
        <button onClick={() => setSidebar(false)} className={styles.closeBtn}><FaTimes /></button>
        {navLinks.map((item, index) => (
          <Link key={index} to={item.path} className={styles.sideLink} onClick={() => setSidebar(false)}>
            {lang === 'EN' ? item.en : item.ur}
          </Link>
        ))}
      </div>
    </header>
  );
};

export default Navbar;